import type { User } from '@auth0/auth0-react'

export function getUserName(user: User | undefined) {
  return user?.name ?? user?.given_name ?? user?.nickname ?? user?.email ?? 'Anonymous'
}

export function getUserInitials(user: User | string | undefined): string {
  const name = typeof user === 'string' ? user : getUserName(user)

  // Email: use first letter before the @
  if (name.includes('@')) {
    return name[0]!.toUpperCase()
  }

  const words = name.trim().split(/\s+/).filter(Boolean)

  // A is for Anonymous
  if (!words.length) return 'A'

  const firstWord = words[0]!
  const firstChar = (firstWord[0] ?? 'A').toUpperCase()

  if (words.length === 1) {
    return firstChar
  }

  const lastWord = words[words.length - 1]!
  const secondChar = (lastWord[0] ?? '').toUpperCase()

  // First and last word initials only (handles middle names / multiple last names)
  return `${firstChar}${secondChar}`
}
